<template>
  <div
    class="col-md-12"
    v-bind:class="{
      tracker: viewState == 'tracker',
      trainer: viewState == 'trainer'
    }"
  >
    <div class="row">
      <form>
        <div class="col-md-7" style="padding-left: 20px;padding-right: 5px;">
          <div class="form-group form-inline">
            Order by
            <select
              class="form-control"
              v-model="orderByColumn"
              style="margin-left:10px;"
            >
              <!-- <option v-for="ob in orderBy" v-bind:value="ob.val"> {{ ob.title}}</option> -->
              <option v-for="(ob, index) in orderBy" v-bind:value="ob.ref" v-bind:key="index">
                {{ ob.title }}
              </option>
            </select>
            <div
              class="btn-group-vertical"
              style="margin-left:10px;margin-right:10px;"
            >
              <div
                class="btn btn-default btn-xs"
                style="font-size:8px;"
                v-on:click="sortOrder = 1"
                v-bind:class="{ active: sortOrder == 1 }"
              >
                <i class="glyphicon glyphicon-menu-up"></i>
              </div>
              <div
                class="btn btn-default btn-xs"
                style="font-size:8px;"
                v-on:click="sortOrder = -1"
                v-bind:class="{ active: sortOrder == -1 }"
              >
                <i class="glyphicon glyphicon-menu-down"></i>
              </div>
            </div>
            then by
            <select
              class="form-control"
              v-model="orderByColumn2"
              style="margin-left:10px;"
              v-on:change="sortOrder2 = 1"
            >
              <option value>----</option>
              <!-- <option v-for="ob in orderBy" v-bind:value="ob.val"> {{ ob.title}}</option>	-->
              <option v-for="(ob, index) in orderBy" v-bind:value="ob.ref" v-bind:key="index">
                {{ ob.title }}
              </option>
            </select>
            <div
              class="btn-group-vertical"
              style="margin-left:10px;margin-right:10px;"
            >
              <div
                class="btn btn-default btn-xs"
                style="font-size:8px;"
                v-on:click="sortOrder2 = 1"
                v-bind:class="{ active: sortOrder2 == 1 }"
              >
                <i class="glyphicon glyphicon-menu-up"></i>
              </div>
              <div
                class="btn btn-default btn-xs"
                style="font-size:8px;"
                v-on:click="sortOrder2 = -1"
                v-bind:class="{ active: sortOrder2 == -1 }"
              >
                <i class="glyphicon glyphicon-menu-down"></i>
              </div>
            </div>
            <span v-show="interviews.length == sortedInterviews.length"
              >{{ interviews.length }} Records</span
            >
            <span v-show="interviews.length != sortedInterviews.length">
              Filtered {{ sortedInterviews.length }} of
              {{ interviews.length }}
            </span>
          </div>
        </div>
      </form>
    </div>
    <div
      class="row scrollable-margins"
      style="width:100%; min-width:1140px;margin-bottom:0px"
    >
      <div class="col-md-12 scrollable-margins">
        <table class="table table-bordered table-striped" id="listhead">
          <thead>
            <tr>
              <th
                v-for="(t, index) in tableStructure"
                v-bind:key="index"
                v-bind:data-ref="t.ref"
                v-bind:style="t.style"
                v-bind:class="{ 'sorted-column': orderByColumn == 't.ref' }"
              >
                <div>
                  {{ t.title }}
                  <span
                    v-if="orderByColumn == t.ref"
                    v-on:click="sortOrder = sortOrder * -1"
                    class="pull-right"
                  >
                    <i
                      class="glyphicon"
                      v-bind:class="{
                        'glyphicon-menu-up': sortOrder > 0,
                        'glyphicon-menu-down': sortOrder < 0
                      }"
                    ></i>
                  </span>
                  <span
                    v-if="orderByColumn2 == t.ref"
                    v-on:click="sortOrder2 = sortOrder2 * -1"
                    class="pull-right"
                  >
                    <i
                      class="glyphicon"
                      v-bind:class="{
                        'glyphicon-menu-up': sortOrder2 > 0,
                        'glyphicon-menu-down': sortOrder2 < 0
                      }"
                    ></i>
                  </span>
                </div>
                <select
                  v-show="t.filtersort == 'dropdown'"
                  class="form-control input-sm"
                  v-model="t.filter"
                >
                  <option value>----</option>
                  <option v-for="(ob, obIndex) in t.options" :key="obIndex" v-bind:value="ob.val">
                    {{ ob.title }}
                  </option>
                </select>
                <input
                  v-show="t.filtersort == 'text'"
                  type="text"
                  class="form-control"
                  v-model="t.filter"
                />
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>

    <div class="row scrollable-margins" style="margin-top:0px;">
      <div class="col-md-12 scrollable-margins">
        <div
          class="container"
          id="list-view"
          style="width:100%;min-width:1140px;top:172px;"
        >
          <div v-on:scroll="handleScroll" id="scrollable">
            <div
              style="box-sizing: border-box;width:100%;overflow:hidden;"
              v-bind:style="itemContainerStyle"
            >
              <table
                class="table table-bordered table-striped"
                v-bind:style="itemsStyle"
                style="margin-bottom:0px"
              >
                <tbody>
                  <tr v-for="(propsitem, propsitemIndex) in visibleInterviews" v-bind:key="propsitemIndex">
                    <td
                      v-for="(t, index) in tableStructure"
                      v-bind:key="index"
                      v-bind:style="'width:' + colWidths[t.ref]"
                      v-bind:title="propsitem[t.ref]"
                    >
                      <div
                        v-if="t.cellType == 'options'"
                        v-bind:class="
                          t.options.filter(function(e) {
                            return e.val == propsitem[t.ref];
                          })[0].val
                        "
                      >
                        {{
                          t.options.filter(function(e) {
                            return e.val == propsitem[t.ref];
                          })[0].title
                        }}
                      </div>
                      <div v-else-if="t.cellType == 'options-icon'">
                        <span v-if="propsitem[t.ref]">
                          <img
                            v-bind:style="
                              t.options.filter(function(e) {
                                return e.val == propsitem[t.ref];
                              })[0].style
                            "
                            v-bind:src="
                              t.options.filter(function(e) {
                                return e.val == propsitem[t.ref];
                              })[0].src
                            "
                          />
                          {{
                            t.options.filter(function(e) {
                              return e.val == propsitem[t.ref];
                            })[0].title
                          }}
                        </span>
                      </div>
                      <div v-else-if="t.cellType == 'clickable-icon'">
                        <span v-if="propsitem[t.cellLink2]">
                          <div
                            class="centerLinks"
                            v-on:click.prevent="
                              linkTo(t.cellLink + propsitem[t.cellLink2])
                            "
                          >
                            <img
                              style="cursor: pointer; width:37px"
                              v-bind:src="t.cellIcon"
                            />
                          </div>
                        </span>
                      </div>
                      <div
                        v-else-if="t.cellType == 'chat-button'"
                        style="padding:5px;"
                      >
                        <chat-button
                          v-bind:propsitem="propsitem"
                          v-bind:openChatModal="openChatModal"
                          v-bind:badgeCountForInterview="badgeCountForInterview"
                        ></chat-button>
                      </div>
                      <div
                        v-else-if="t.cellType == 'emitButton'"
                        style="
                          overflow: auto !important;
                          white-space: normal !important;
                        "
                        class="form-inline"
                      >
                        <span
                          v-if="t.icon"
                          v-bind:class="t.icon"
                          v-on:click="emitButton(propsitem, t.ref)"
                        ></span>
                        <button
                          v-else
                          class="btn btn-default"
                          v-on:click="emitButton(propsitem, t.ref)"
                        >
                          {{ t.title }}
                        </button>
                      </div>
                      <div
                        v-else-if="t.cellType == 'value-or-button'"
                        :style="t.cellStyle"
                      >
                        <span v-if="propsitem[t.ref]">{{ propsitem[t.ref] }}</span>
                        <button
                          v-else
                          class="btn btn-default btn-xs"
                          v-on:click="emitButton(propsitem, t.emitEvent || t.ref)"
                        >
                          {{ t.buttonTitle || 'Action' }}
                        </button>
                      </div>
                      <div v-else :style="t.cellStyle">{{ propsitem[t.ref] }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
// import VueResource from "vue-resource";
// Vue.use(VueResource);
// import VeeValidate from "vee-validate";
// Vue.use(VeeValidate);

// import {
//   ivModalMixin,
//   ivAlertMixin,
//   ivSpinnerMixin,
//   getParameterByName,
//   ivUserInfoMixin
// } from "/code/s/js/base-components-pack.js";
// import { counselorTwilioMixin } from "/code/s/js/counselor-bedelia-mixin.js";

// import * as ivapi from "/code/s/js/ivapi-pack.js";
// import ivbus from "/code/s/js/ivbus-pack.js";

// Vue.component("chat-button", {
//   props: ["propsitem", "openChatModal", "badgeCountForInterview"],
//   template:
//     "<div v-if=\"propsitem.interviewStatus != 'invited'\">" +
//     '<button class="btn btn-default text-center btn-sm btn-block btn-send-message" v-on:click="openChatModal(propsitem)">' +
//     "<span>SEND MESSAGE</span>" +
//     '<span class="badge" v-if="badgeCountForInterview(propsitem) > 0">{{badgeCountForInterview(propsitem)}}</span>' +
//     "</button>" +
//     "</div>"
// });

export default {
  // mixins: [
  //   ivModalMixin,
  //   ivAlertMixin,
  //   ivSpinnerMixin,
  //   ivUserInfoMixin,
  //   counselorTwilioMixin,
  //   orgSupportMixin
  // ],

  props: {
    tableStructure: {
      type: Array,
      default: function() {
        return [];
      }
    },
    interviews: {
      type: Array,
      default: function() {
        return [];
      }
    },
    initialOrderBy: {
      type: String,
      default: ""
    },
    viewState: {
      type: String,
      default: ""
    },
    itemheight: {
      type: Number,
      default: 40
    }
  },
  data() {
    return {
      colWidths: {},

      // orderBy: [
      //     {val: "status", title: "INTERVIEW STATUS"},
      //     {val: "lastName", title: "LAST NAME"},
      //     {val: "firstName", title: "FIRST NAME"},
      //     {val: "email", title: "EMAIL"},
      //     {val: "alertReminder", title: "ALERT / REMINDER"},
      // ],

      // // sort columns
      orderByColumn: this.initialOrderBy,
      orderByColumn2: "",
      sortOrder: 1,
      sortOrder2: 0,

      // virtual scrolling:
      $_startIndex: 0,
      itemContainerStyle: null,
      itemsStyle: null,
      scroll: {
        top: 0,
        bottom: 0
      }
    };
  },

  computed: {
    orderBy: function() {
      var that = this;
      return that.tableStructure.filter(function(t) {
        return t.orderBy == true;
      });
    },

    filteredInterviews: function() {
      var that = this;
      that.page_num = 1;
      that.lastSelectedRow = null;
      that.lastSelectedRowIndex = null;
      return that.interviews.filter(function(iv) {
        var match = true;
        iv.checked = false;
        that.tableStructure.forEach(function(t) {
          if (match && t.filter && t.filtersort == "text") {
            match =
              iv[t.ref] &&
              iv[t.ref].toLowerCase().indexOf(t.filter.toLowerCase()) !== -1;
          }
          if (match && t.filter && t.filtersort == "dropdown") {
            match = iv[t.ref] == t.filter;
          } // check for 0 vs null
        });
        return match;
      });
    },
    sortedInterviews: function() {
      var that = this;
      return this.filteredInterviews.slice().sort(function(a, b) {
        var aVal = a[that.orderByColumn] || "";
        var bVal = b[that.orderByColumn] || "";
        var a2Val = that.orderByColumn2 ? a[that.orderByColumn2] || "" : "";
        var b2Val = that.orderByColumn2 ? b[that.orderByColumn2] || "" : "";
        var so = that.sortOrder;
        var so2 = that.sortOrder2;
        return aVal > bVal
          ? so
          : aVal < bVal
          ? -1 * so
          : a2Val > b2Val
          ? so2
          : a2Val < b2Val
          ? -1 * so2
          : 0;
      });
    },

    visibleInterviews: function() {
      var _this2 = this;

      var l = _this2.sortedInterviews.length;
      var itemHeight = this.itemheight;
      var containerHeight = void 0,
        offsetTop = void 0;

      var scroll = this.scroll;

      if (scroll) {
        var startIndex = -1;
        var endIndex = -1;

        var buffer = 200;
        var poolSize = 2000;
        var scrollTop = ~~(scroll.top / poolSize) * poolSize - buffer;
        var scrollBottom =
          Math.ceil(scroll.bottom / poolSize) * poolSize + buffer;

        _this2.$_oldScrollTop = scrollTop;
        _this2.$_oldScrollBottom = scrollBottom;

        // Fixed height mode
        startIndex = ~~(scrollTop / itemHeight);
        endIndex = Math.ceil(scrollBottom / itemHeight);

        // Bounds
        startIndex < 0 && (startIndex = 0);
        endIndex > l && (endIndex = l);

        offsetTop = startIndex * itemHeight;
        containerHeight = l * itemHeight;

        if (
          _this2.$_startIndex !== startIndex ||
          _this2.$_endIndex !== endIndex ||
          _this2.$_offsetTop !== offsetTop ||
          _this2.$_height !== containerHeight ||
          _this2.$_length !== l
        ) {
          _this2.keysEnabled = !(
            startIndex > _this2.$_endIndex || endIndex < _this2.$_startIndex
          );

          Vue.set(_this2, "itemContainerStyle", {
            height: containerHeight + "px"
          });
          Vue.set(_this2, "itemsStyle", {
            marginTop: offsetTop + "px"
          });

          _this2.$_startIndex = startIndex;
          _this2.$_endIndex = endIndex;
          _this2.$_length = l;
          _this2.$_offsetTop = offsetTop;
          _this2.$_height = containerHeight;
        }
      }

      return this.sortedInterviews.slice(
        _this2.$_startIndex,
        _this2.$_endIndex
      );
    }
  },

  mounted: function() {
    var that = this;
    $(window).on("load", function() {
      window.setTimeout(function() {
        that.cacheColWidths();
        that.handleScroll();
      });
    });
    $(window).on("resize", this.cacheColWidths);
    $("#list-view").height($(window).height() - 480);
  },

  methods: {
    handleScroll: function() {
      var el = $("#scrollable")[0];
      var scroll = {
        top: el.scrollTop,
        bottom: el.scrollTop + el.clientHeight
      };

      if (scroll.bottom >= 0 && scroll.top <= scroll.bottom) {
        Vue.set(this, "scroll", scroll);
      } else {
        Vue.set(this, "scroll", null);
      }
    },

    cacheColWidths: function() {
      var that = this;
      $("#listhead")
        .find("th")
        .each(function() {
          Vue.set(
            that.colWidths,
            $(this).attr("data-ref"),
            $(this).outerWidth() + "px"
          );
        });
    },

    dateFormat: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    emitButton: function(item, ref) {
      this.$emit(ref, item);
    },

    linkTo: function(link) {
      window.open(link, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.tracker {
  thead {
    background-color: #e96724;
    color: #eee;
  }

  .table-bordered > tbody > tr > td {
    border: 1px solid #e96724;
  }
  .modalMessageStudent {
    border: solid 2px #e96724;
  }
}

.trainer {
  thead {
    background-color: #79a9ad;
    color: #eee;
  }

  .table-bordered > tbody > tr > td {
    border: 1px solid #79a9ad;
  }

  .modalMessageStudent {
    border: solid 2px #79a9ad;
  }
}

.title {
  font-size: 40px;
  margin-left: 15px;
  color: rgb(221, 83, 38);
  font-weight: lighter;
}

.subtitle {
  margin-top: 5px;
  margin-left: 15px;
  font-size: 23px;
  font-weight: 300;
  color: rgb(221, 83, 38);
  font-weight: bold;
}

.ticker-area {
  /* background-color: rgb(254,239,234); */
  background-color: white;
  margin-top: 0px;
  margin-bottom: 0px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgb(181, 181, 181);
  border: solid 1px rgb(181, 181, 181);
  padding: 9px 12px;
}

.ticker-label {
  color: rgb(221, 83, 38);
  font-size: 75%;
  font-weight: lighter;
  text-align: right;
}

.ticker-label p {
  margin-bottom: 0px;
  padding-right: 10px;
}

.ticker {
  background-color: rgb(221, 83, 38);
  font-size: 150%;
  color: white;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.arrow-left {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 7px solid rgb(221, 83, 38);
  position: absolute;
  left: -7px;
  top: 14px;
}

/* CSS FOR Review Template */

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Lato";
}
p,
div {
  font-family: "Lato";
}

#scrollable {
  height: 100%;
  overflow-y: auto;
  -ms-overflow-y: auto;
}

#scrollable table {
  table-layout: fixed;
}

#scrollable td div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Bedelia Popover */

.popover {
  max-width: 376px;
  width: 376px;
}

.popover-content {
  padding: 4px;
  height: 600px;
  overflow-y: scroll;
}

.popover .unread {
  font-weight: bold;
  background-color: rgba(243, 96, 0, 0.2);
}

.bedelia-instructions {
  width: 600px;
}

.tooltip.bedelia.in {
  filter: alpha(opacity=100);
  opacity: 1;
}

.tooltip.bedelia {
  margin-top: 120px; /* Use to change vertical position */
}
/* LIST VIEW */
#list-view {
  /*position:absolute;
    left:0px;
    right:0px;
    top:110px;
    bottom:50px;*/
  width: 100%;
  /*height:100%;*/
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  /*   border: solid blue 1px;
    overflow-y:scroll;*/
}

.navbar-form-thin {
  margin: 0px;
  padding-top: 10px;
  padding-bottom: 6px;
  height: 56px;
}

.nav-badge {
  padding-top: 15px;
  padding-right: 10px;
  padding-left: 10px;
}

.hrLessMargin {
  margin: 4px;
}

/*****************************/
div ::v-deep .btn-send-message {
  color: rgb(180, 33, 39);
  font-size: 80%;
  background-color: rgb(237, 237, 238);
  padding: 2px 9px;
  border-radius: 5px;
}

.btn-submit-message {
  color: white;
  background-color: rgb(221, 82, 37);
  padding: 10px 40px;
  border-radius: 14px;
  font-size: 124%;
  font-weight: lighter;
}

.modalMessageStudent {
  border-radius: 15px;
  padding: 10px;
  margin-top: 100px;
}

.modalRotate {
  color: rgb(221, 82, 37);
  font-size: 255%;
  font-weight: lighter;
  transform: rotate(90deg);
  width: 20px;
  position: fixed;
  right: 20px;
  top: 43px;
}

.modalLabel {
  color: rgb(221, 82, 37);
  margin-top: 22px;
  font-size: 120%;
}

.modalInfo {
  border: solid 2px rgb(221, 82, 37);
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 110%;
  margin-bottom: 25px;
}

.modalInfoDetails {
  color: rgb(221, 82, 37);
  font-size: 90%;
  font-style: italic;
}

.modelInput {
  border: solid 2px rgb(221, 82, 37);
  border-radius: 15px;
  margin-bottom: 25px;
  padding: 15px;
}

/*****************************/

.scrollable-margins {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
}

#listhead {
  margin-bottom: 0px;
}

#list-view-nav {
  top: 50px;
  height: 60px;
}

#listPageSearchInput {
  width: 300px;
}

th.sortable:hover {
  background-color: #222;
}

th input.form-control {
  height: 24px;
  padding: 4px;
  margin-top: 7px;
}

.nowrap {
  white-space: nowrap;
}

.centerLinks {
  text-align: center;
}

#list-dropdown {
  width: 86px;
}

.list-star > img {
  display: block;
  margin: auto;
}

.sorted-column {
  /*background-color: black;*/
}

td.review-score {
  font-size: 20pt;
  text-align: center;
}

td {
  font-size: 10pt;
}

/* 
  #e96724 --orange

  #79a9ad --blue 

  #ebeff1  --almost white background
  */

/* bootstrap override */
nav {
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

.dropdown-menu {
  background-color: #ebeff1;
}

.form-control {
  background-color: #ebf1f2;
}

.list-spinner .iv-spinner {
  position: absolute;
  top: 35px;
  left: 15%;
  margin: -25px 0 0 -25px;
  opacity: 0.85;
  text-align: left;
  border: 6px solid #adadad;
  box-sizing: border-box;
  background-clip: padding-box;
  width: 35px;
  height: 35px;
  border-radius: 25px;
}

.table > tbody > tr > td {
  padding: 0px;
}

.table > tbody > tr > td > div {
  padding: 8px;
  height: 36px;
}

.invited {
  background-color: #f9fce1;
}

.complete {
  background-color: #ffe3c6;
}

.ready {
  background-color: #ffe3c6;
}
.sent {
  background-color: #dbfddf;
}
.processing {
  background-color: #ddfdfd;
}

.booked {
  background-color: #ddfdfd;
}

.badge.badge-danger {
  color: #f2dede;
  background-color: #a94442;
}
.badge.badge-success {
  color: #dff0d8;
  background-color: #3c763d;
}
</style>
